import {
  WORKFLOWSTART_START,
  WORKFLOWSTART_SUCCESS,
  WORKFLOWSTART_ERROR,
  WORKFLOWSTART_CLEAR, SET_WORKFLOWSTART_DATA,
} from 'actions/payway';

const initialState = {
  inProgress: false,
  success: null,
  error: null,
  data: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case WORKFLOWSTART_START: {
      return {
        origin: window.location.pathname,
        inProgress: true,
        success: null,
        error: null,
        data: null,
      };
    }
    case WORKFLOWSTART_SUCCESS: {
      return {
        origin: state.origin,
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case SET_WORKFLOWSTART_DATA: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case WORKFLOWSTART_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    case WORKFLOWSTART_CLEAR: {
      return {...initialState};
    }
    default: {
      return state;
    }
  }
}
